import UnknownError from './UnknownError';

export default UnknownError;
